import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { NumericFormat } from 'react-number-format';
import { useState, forwardRef, Fragment } from "react";
import { Button, Divider, List, ListItem, ListItemText, Stack, TextField, Typography } from '@mui/material';
import MySportSpaceAlert from '../../alert/alert.component';
import MySportSpaceLoadingView from '../../my-sport-space-loading-view/my-sport-space-loading-view.component';
import { ApplyAjustmentToBookedParty } from '../../../utils/birthday-api/birthday-service';
import { DeciamlFormat } from '../../../utils/text-field-utils/text-field-utils';

const NumberFormat = forwardRef(
    function NumberFormatCustom(props, ref) {
        const { onChange, id, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                            id: id
                        },
                    });
                }}
                decimalScale={2}
            />
        );
    },
)

const defaultFormFields = {
    amount: '0',
    reason: ''
}

const BirthdayPartyAdjustBookedParty = ({ isOpen, bookedPartyId, adjustmentType, close, refresh }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [ adjustedMessage, setAdjustedMessage ] = useState(null);
    const [formFields, setFormFields] = useState(defaultFormFields);
    const { amount, reason } = formFields;

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormFields({ ...formFields, [name]: value });
    };

    const applyAdjustment = async () => {

        if (!amount || parseFloat(amount) <= 0) {
            setAlertMessage("You must provide an amount greater than zero");
            return;
        }

        if (!reason || reason.length <= 0) {
            setAlertMessage("You must provide a reason.");
            return;
        }

        setIsLoading(true);
        const applyAdjustmentResonse = await ApplyAjustmentToBookedParty(adjustmentType, amount, bookedPartyId, reason );
        let success = false;
        let responseMessage = "An unexpected error occurred, the adjustment was NOT applied"
        if (applyAdjustmentResonse && applyAdjustmentResonse.status === 200) {
            const { status, message} = applyAdjustmentResonse.data;
            if (status === 'success') {
                success = true;
            }
            responseMessage = message;
        }

        if (success) {
            setAdjustedMessage(responseMessage);
            if (refresh) {
                refresh();
            }
        } else {
            setAlertMessage(responseMessage);
        }
        setIsLoading(false);
    }

    const closeThisView = () => {
        setAlertMessage(null);
        setAdjustedMessage(null);
        close();
    }

    const closeAlert = () => {
        setAlertMessage(null);
    }

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="adjust-amount-dialog-title"
            aria-describedby="adjust-amount-dialog-description"
        >
            <MySportSpaceAlert isOpen={!isLoading && adjustedMessage ? true : false} key='adjusted-birthdayparty-alert' message={adjustedMessage} okButtonText={'OK'} okAction={closeThisView}></MySportSpaceAlert>
            <MySportSpaceAlert isOpen={!isLoading && alertMessage ? true : false} key='adjust-birthdayparty-alert' message={alertMessage} okButtonText={'OK'} okAction={closeAlert}></MySportSpaceAlert>
            <MySportSpaceLoadingView isOpen={isLoading}></MySportSpaceLoadingView>
            <DialogTitle id="adjust-amount-dialog-title">
                {`${adjustmentType} Birthday Party`}
            </DialogTitle>
            <DialogContent>
                <Divider></Divider>
                {
                    adjustmentType && adjustmentType === 'Refund' &&
                    <Fragment>
                        <List>
                            <ListItemText>Refunds will be applied to the birthday party price, minus any initial deposit. </ListItemText>
                            <ListItemText>If a party has been paid, a refund will be issued for the amount.</ListItemText>
                            <ListItemText>If a party has not been paid, the total amount due will be adjusted.</ListItemText>
                            <ListItemText>To refund a deposit use "Refund Deposit"</ListItemText>
                        </List>
                        <Divider></Divider>
                    </Fragment>
                }

                <DialogContentText mt={1}>
                    {`Enter ${adjustmentType} Amount And Reason`}
                </DialogContentText>
                <TextField InputProps={{
                    inputComponent: DeciamlFormat,
                }} required fullWidth sx={{ ml: '1.0vw', mr: '1.0vw', mt: '2.0vh' }} id="birthdayparty-adjust-amount" variant="outlined" label="Amount" type="text" name="amount" value={amount} onChange={handleChange} ></TextField>
                <TextField required fullWidth sx={{ ml: '1.0vw', mr: '1.0vw', mt: '2.0vh' }} id="birthdayparty-adjust-reason" variant="outlined" label="Reason" type="text" name="reason" value={reason} onChange={handleChange} ></TextField>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeThisView}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={applyAdjustment}>
                    {`Apply ${adjustmentType}`}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default BirthdayPartyAdjustBookedParty;